<template>
  <section class="content" style="padding:unset;">
    <div class="row">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 serch-barr">

        <div class="row">
          <div class="col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2">
            <p class="home-topic" style="padding-top: 11%;">Products</p>
          </div>
          <div class="col-3 col-sm-3 col-md-8 col-lg-8 col-xl-8">

            <div class="searchBar" style="padding-top: 2%;">
              <input type="text" v-model="searchField" v-on:keyup.enter="getAllProduct()"  class="searchTerm" placeholder="Search by Product Name / Code">
              <button type="submit" class="searchButton">
                <i class="fa fa-search" @click="getAllProduct()"></i>
              </button>
            </div>
          </div>
          <div class="col-3 col-sm-3 col-md-2 col-lg-2 col-xl-2">
            <md-field class="dddBox">
              <md-select class="dropDown"  name="orderBy" id="orderBy" v-model="selectedCate" placeholder="Sort Products" @md-selected="getAllProduct()">
                <md-option :value="cata.id" v-for="cata in allCategory" v-bind:key="cata.id" >{{cata.name}}
                </md-option>
              </md-select>
            </md-field>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <div class="row">
          <div class="col-6 col-sm-6 col-md-3 col-lg-3 col-xl-3" v-for="item in allProduct" v-bind:key="item.id">
            <!-- <router-link :to="'/videos/single-video/'+video.category_id+'/'+video.id"> -->
              <div class="v-boxx">
                <div class="v-videoo">
                  <img  :src="item.thumbnail_medium"  alt="...">
                </div>
                <div class="v-content">
                    <!-- <div class="cart-bar">
                        <div class="cart-body">
                            <button v-if="checkUser" class="cart-btnn clear-new-modal"><i style="font-size: 18px;" class="fa fa-shopping-basket" aria-hidden="true"></i></button>
                        </div>
                    </div> -->
                    <div class="v-name two-line-overflow" v-html="item.name"></div>
                    <div class="space-5px"/>
                    <div class="v-disc two-line-overflow" v-html="item.description"></div>
                    <div class="space-5px"/>
                    <router-link :to="'products-view/single-product/'+item.id">
                      <button class="btn primary-btn-my">View More</button>
                    </router-link>
                </div>

              </div>
            <!-- </router-link> -->
          </div>
        </div>
      </div>
    </div>

    <div class="row" v-if="noContent==='yes'">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        No results found
      </div>
    </div>
    <div class="row" v-if="noContentErrorMsg">
      <!--        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">-->
      <vue-content-loading :width="300" :height="100">
        <rect x="0" y="13" rx="4" ry="4" width="23%" height="50"/>
        <rect x="0" y="66" rx="2" ry="2" width="23%" height="3"/>
        <rect x="0" y="72" rx="2" ry="2" width="14%" height="3"/>
        <rect x="0" y="78" rx="2" ry="2" width="23%" height="3"/>
        <rect x="0" y="84" rx="2" ry="2" width="23%" height="3"/>

        <rect x="25%" y="13" rx="4" ry="4" width="23%" height="50"/>
        <rect x="25%" y="66" rx="2" ry="2" width="23%" height="3"/>
        <rect x="25%" y="72" rx="2" ry="2" width="14%" height="3"/>
        <rect x="25%" y="78" rx="2" ry="2" width="23%" height="3"/>
        <rect x="25%" y="84" rx="2" ry="2" width="23%" height="3"/>

        <rect x="51%" y="13" rx="4" ry="4" width="23%" height="50"/>
        <rect x="51%" y="66" rx="2" ry="2" width="23%" height="3"/>
        <rect x="51%" y="72" rx="2" ry="2" width="14%" height="3"/>
        <rect x="51%" y="78" rx="2" ry="2" width="23%" height="3"/>
        <rect x="51%" y="84" rx="2" ry="2" width="23%" height="3"/>

        <rect x="77%" y="13" rx="4" ry="4" width="23%" height="50"/>
        <rect x="77%" y="66" rx="2" ry="2" width="23%" height="3"/>
        <rect x="77%" y="72" rx="2" ry="2" width="14%" height="3"/>
        <rect x="77%" y="78" rx="2" ry="2" width="23%" height="3"/>
        <rect x="77%" y="84" rx="2" ry="2" width="23%" height="3"/>
      </vue-content-loading>
      <!--        </div>-->
    </div>

<!--    <div class="row">-->
<!--      <scroll-loader :loader-method="getVideos" :loader-enable="this.loaderEnable">-->
<!--      </scroll-loader>-->
<!--    </div>-->
<div class="row">
      <div style="float: right;" v-if="allProduct.length!=0">
        <ul class="pagination">
          <li v-bind:class="{disable:pagination.current_page===pagination.from}" class="page-item">
            <a
              @click="pagination.current_page!==pagination.from && getAllProduct(pagination.first_page_url)"
              class="page-link"
            >&laquo;</a>
          </li>
          <li v-bind:class="{disable:!pagination.prev_page_url}" class="page-item">
            <a @click="pagination.current_page!==pagination.from && getAllProduct(pagination.prev_page_url)" class="page-link">&lt;</a>
          </li>
          <li
            v-for="n in pagination.last_page"
            v-bind:key="n"
            v-bind:class="{active:pagination.current_page == n}"
            class="page-item"
          >
            <a
              @click="pagination.current_page!==n && getAllProduct(pagination.path + '&page=' + n)"
              class="page-link"
            >{{n}}</a>
          </li>
          <li v-bind:class="{disable:!pagination.next_page_url}" class="page-item">
            <a @click="pagination.current_page!==pagination.last_page && getAllProduct(pagination.next_page_url)" class="page-link">&gt;</a>
          </li>
          <li v-bind:class="{disable:!pagination.last_page_url}" class="page-item">
            <a
              @click="pagination.current_page!==pagination.last_page && getAllProduct(pagination.last_page_url)"
              class="page-link"
            >&raquo;</a>
          </li>
        </ul>
      </div>
    </div>
    <back-to-top bottom="120px" right="20px" visibleoffset="20">
      <button type="button" class="scoller-top-btn"><i class="fa fa-chevron-up"></i></button>
    </back-to-top>
  </section>
</template>
<script>
  import api from '../../../api'
  import dropdown from 'vue-dropdowns'
  import Alert from '../../widgets/Alert'
  import InfoBox from '../../widgets/InfoBox'
  import ProcessInfoBox from '../../widgets/ProcessInfoBox'
  import SmallBox from '../../widgets/SmallBox'
  import BackToTop from 'vue-backtotop'

  import VueContentLoading from 'vue-content-loading'

  export default {
    name: 'homeView',
    components: {
      Alert,
      InfoBox,
      ProcessInfoBox,
      SmallBox,
      'dropdown': dropdown,
      VueContentLoading,
      BackToTop
    },
    data() {
      return {
        checkUser: false,
        page: 0,
        pageSize: 10,
        ItemList: [],
        loaderEnable: true,
        selectCata: '',
        selectProduct: '',
        selectedCate: '',
        allProduct: [],
        searchField: '',
        noContent: 'no',
        noContentErrorMsg: true,
        pagination: {},
        allCategory: []
      }
    },
    mounted() {
    },
    created() {
      this.getCategory()
      this.getAllProduct()
    },
    methods: {
      viewMore(id) {
        this.$router.push('products-view/single-product/' + id)
      },
      getAllProduct(pagi = null) {
        console.log(pagi)
        var URL = ''
        if (pagi) {
          URL = pagi
        } else {
          URL = '/customer/productcatalog/mobile?category_id=' + this.selectedCate + '&search=' + this.searchField + '&orderby=DESC'
        }
        this.noContentErrorMsg = true
        api.request('get', URL)
          .then(response => {
            this.allProduct = response.data.result
            this.pagination = response.data.pagination
            this.noContentErrorMsg = false
          })
      },
      getCategory() {
        api.request('get', '/admin/catalog_category/select')
          .then(response => {
            var result = response.data.data

            if (result.length > 0) {
              result.splice(0, 0, {id: 0, name: 'All'})
            }
            this.allCategory = result
          })
      }
    }
  }
</script>
<style>
  @media (min-width: 320px) and (max-width: 480px) {
    .video-list-thumbs .glyphicon-play-circle {
      font-size: 35px;
      right: 36%;
      top: 27%;
    }

    .video-list-thumbs h2 {
      bottom: 0;
      font-size: 12px;
      height: 22px;
      margin: 8px 0 0;
    }
  }

  .top-right {
    position: absolute;
    top: 8px;
    right: 16px;
  }
</style>



// WEBPACK FOOTER //
// ProductsView.vue?01f1c94b